import React from "react";
import classnames from "classnames";
import * as actions from "../actions/actions";
import * as actionTypes from "../actions/actionTypes";
import Loading from "./loading";

import {
    WITH_ATTRIBUTION,
    NO_ATTRIBUTION,
    makeSvgKey
} from "../reducers/icons";

import cleanPreviewIcon from "../helpers/clean_svg_string";
import { connect } from "react-redux";

class NounProjectIconView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...this.setPreviewIcon(props),
            ...this.setTransparentBG(props)
        };
    }

    componentWillMount() {
        this.fetchSvg(this.props);
    }

    componentDidMount() {
        this.setState(this.setPreviewIcon(this.props));
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.setTransparentBG(nextProps));
        this.fetchSvg(nextProps);

        if (
            !nextProps.loading &&
            nextProps.cachedSvg &&
            nextProps.cachedKey == this.state.fetchingSvg
        ) {
            this.setState({
                fetchingSvg: null,
                fetchingSvgUrl: null
            });
        }

        this.setState(this.setPreviewIcon(nextProps));
    }

    fetchSvg(props) {
        let attribution = props.withAttribution
            ? WITH_ATTRIBUTION
            : NO_ATTRIBUTION;
        let cachedKey = props.cachedKey;

        let shouldLoad = !props.cachedSvg || props.loading;
        let isNotAlreadyFetching = this.state.fetchingSvg !== cachedKey;
        let hasFailed =
            props.apiResponse &&
            props.apiResponse.actionType == actionTypes.FETCH_SVG_DATA_FAILURE;

        let { icon } = props;
        let iconUrl;
        if (icon) {
            iconUrl = icon.icon_url;
            if (props.withAttribution) {
                iconUrl = icon.attributionPreviewUrl;
            }
        }

        // If the previous attempt failed, but a new url is available in
        // case the new url has been resigned and is now valid
        let shouldRetry = hasFailed && iconUrl != this.state.fetchingSvgUrl;

        if (iconUrl && ((shouldLoad && isNotAlreadyFetching) || shouldRetry)) {
            this.setState({
                fetchingSvg: cachedKey,
                fetchingSvgUrl: iconUrl,
                cleanedSvg: null
            });
            this.props.fetchSVGData(iconUrl, props.icon.id, attribution);
        }
    }

    setTransparentBG(props) {
        let { selectedColor, edited, withAttribution } = props;
        return {
            transparentBG:
                !withAttribution && (selectedColor !== "#000000" || edited)
        };
    }

    setPreviewIcon(props) {
        let { cachedSvg, withAttribution, edited } = props;

        let iconImageBackground;
        let contentType = "image/svg+xml";
        if (props.icon) {
            if (withAttribution) {
                iconImageBackground = props.icon.attributionPreviewUrl;
                contentType = "image/png";
            } else {
                iconImageBackground = props.icon.icon_url;
            }
        }
        let newState = {
            iconImageBackground
        };

        if (cachedSvg) {
            if (
                this.state &&
                this.state.cleanedSvg &&
                this.state.selectedColor == this.state.cleanedSvgColor
            ) {
                newState.iconImageBackground = this.state.cleanedSvg;
            } else {
                let newSvg;
                if (withAttribution) {
                    newSvg = cachedSvg;
                } else {
                    if (edited) {
                        newSvg = cachedSvg;
                    } else {
                        newSvg = cleanPreviewIcon(
                            cachedSvg,
                            props.selectedColor,
                            !props.imgSize ? "300px" : props.imgSize
                        );
                    }
                    newSvg = unescape(encodeURIComponent(newSvg));
                }
                iconImageBackground =
                    `data:${contentType};base64,` + btoa(newSvg);

                newState = {
                    iconImageBackground,
                    cleanedSvg: iconImageBackground,
                    cleanedSvgColor: props.selectedColor
                };
            }
        }

        return newState;
    }

    render() {
        let { imgSize, withAttribution, loading, edited } = this.props;

        let containerStyle = {
            position: "relative",
            width: "100%",
            height: imgSize
        };

        if (imgSize) {
            containerStyle.minHeight = "0";
        }

        let previewIcon;

        if (this.props.cachedSvg) {
            let previewClasses = classnames("iconPreview");
            if (this.state.iconImageBackground) {
                let style = {
                    backgroundImage:
                        "url(" + this.state.iconImageBackground + ")"
                };

                if (!loading) {
                    previewClasses = classnames(previewClasses, {
                        "with-attribution": withAttribution,
                        "no-attribution": !withAttribution
                    });
                }

                previewIcon = <div className={previewClasses} style={style} />;
            }
        } else {
            previewIcon = <Loading />;
        }

        let iconContainerClass = classnames("the-icon-container", {
            updated: this.state.transparentBG && !!this.props.cachedSvg,
            edited
        });

        return (
            <div className={iconContainerClass} style={containerStyle}>
                {previewIcon}
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    let { download, apiResponse, editor } = state;

    // Wrapped SVGs don't need to be scaled down to fit in the icon view
    let edited = editor.needsWrap;
    let icon, currentUser, selectedColor;
    let { withAttribution } = props;

    if (props.icon) {
        icon = props.icon;
    } else if (state.icons.active_icon) {
        icon = state.icons.active_icon;
    }

    if (editor.transforms && editor.transforms.color) {
        selectedColor = editor.transforms.color;
    }

    let cachedSvg, cachedKey, loading;
    if (icon) {
        let { icons } = state;
        let svgKey;
        let storeIcon = icons.active_icon;

        if (!storeIcon || storeIcon.id != icon.id) {
            if (icons[icon.id]) {
                storeIcon = icons[icon.id];
            } else {
                storeIcon = { id: icon.id };
            }
        }

        if (props.withAttribution) {
            svgKey = makeSvgKey(WITH_ATTRIBUTION);
        } else {
            svgKey = makeSvgKey(NO_ATTRIBUTION);
        }

        if (!props.withAttribution && edited) {
            if (editor.svg) {
                cachedSvg = editor.svg;
            } else {
                loading = true;
            }
        } else {
            cachedSvg = storeIcon[svgKey];
        }
        cachedKey = `${storeIcon.id}-${svgKey}`;

        if (!cachedSvg) {
            loading = true;
        }
    }

    return {
        apiResponse,
        icon,
        cachedKey,
        cachedSvg,
        loading,
        selectedColor,
        edited,
        transforms: editor.transforms
    };
}

export default connect(
    mapStateToProps,
    {
        fetchSVGData: actions.fetchSVGData
    }
)(NounProjectIconView);
